import { LoadingButton } from '@mui/lab';
import { Box, FormControl, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const defaultValues = {
  voucherID: '',
};

export const WarehouseTransferReceiptForm = ({ onSubmit, loading = false }) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    reset(defaultValues);
  }, [reset]);

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(data =>
        onSubmit?.({
          voucherID: Number.parseInt(data.voucherID, 10),
        }),
      )}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        pt: 1,
        minWidth: 300,
      }}
    >
      <FormControl variant="standard" sx={{ minWidth: 280 }}>
        <TextField
          autoFocus
          label="شناسه حواله"
          variant="standard"
          type="number"
          inputProps={{ inputMode: 'numeric' }}
          {...register('voucherID', {
            required: 'شناسه حواله الزامی است',
            validate: value =>
              Number.isFinite(Number.parseInt(value, 10)) ||
              'شناسه حواله معتبر نیست',
          })}
          error={isSubmitted ? !!errors.voucherID : false}
          helperText={isSubmitted ? errors.voucherID?.message : null}
        />
      </FormControl>

      <LoadingButton
        type="submit"
        color="warning"
        variant="contained"
        loading={loading}
        sx={{ minWidth: 120 }}
      >
        ثبت
      </LoadingButton>
    </Box>
  );
};
